@if (isRechargeSchedule && confirmRechargeSchedule) {
  <div class="dialog-recharhe-container">
    <div class="dialog-recharhe-container__title">
      Domiciliarás el pago de tu recarga celular por<br><span>{{ amount |currency :'MXN': 'symbol-narrow':'.2-2' }} MXN {{frecuency}}.</span>
    </div>
    <div class="dialog-recharhe-container__icon">
      <app-basic-card
        type="none"
        [picture]="billerLogo ? { value: billerLogo, type: 2 } : { type: 1, value: 'mobile' }"
      ></app-basic-card>
    </div>
    <div class="dialog-recharhe-container__data">
      <span class="dialog-recharhe-container__data--title">{{ alias }}</span>
      <span>{{cel | mask: '00 0000 0000'}}</span>
    </div>

    <div class="dialog-recharhe-details">
      @for (item of arrayDetailsRecharges; track item.id) {
        <div class="dialog-recharhe-details__item">
          <span>{{ item.label }}</span>
          <span>{{ item.value }}</span>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="confirm-dialog">
    <div class="title">{{ labels.title }}</div>
    <app-basic-card class="card" [picture]="{ type: 0, value: card.imageCode}" type="none">
      <div class="info -space">
        <p class="name">{{ card.account.product.productName}}</p>
        <p class="text">{{buildDetailAccount}}</p>
      </div>
    </app-basic-card>
    <div class="amount">
      <img class="divider" src="assets/images/Divider.svg" alt="divider">
      <flame-icon class="icon" svgIcon="send" size="xs"></flame-icon>
      <p class="text">$&nbsp;{{ amount | currency:"MXN" : "" }} MXN</p>
    </div>
    <app-basic-card class="company" [picture]="picture" type="none">
      <div class="info">
        <p class="name">{{ biller.name }}</p>
        <p class="text">{{ cel | mask: '00 0000 0000'}}</p>
      </div>
    </app-basic-card>
  </div>
}

<div class="confirm-button">
  <button
    flameButton
    color="primary"
    (click)="changeSlideSuccess()"
  >
    Continuar
  </button>
</div>
